import { saveAs } from 'file-saver'
import SwalCustom from '../../../alert/swal-custom'
import { fnDateEn } from '../../../helper/fnDateEn'
import { createSpreadsheetBlob } from '../../../helper/spreadsheet/write-spreadsheet'
import { buildEducationReportSheet } from '../../../helper/spreadsheet/education-report'

export default async function ExportExcel({ filterEx = [], data = [] }) {
  const { sheetData, sheetOptions } = buildEducationReportSheet({
    filterEx,
    data
  })
  const blob = await createSpreadsheetBlob(sheetData, sheetOptions)

  saveAs(
    blob,
    `Report-Education-${fnDateEn(new Date()).format('YYMMDDHHmmss')}`
  )
  SwalCustom({
    title: 'Success!',
    text: 'Exported',
    icon: 'success',
    showConfirmButton: false,
    timer: 1500
  })
}
